import { SURVEY_INPUT_PROCESSING_STATES } from '../Constants';
import { checkUserGroup, USER_GROUPS } from './AuthUtils';

export const DATA_PROVIDER_ALLOWED_STATUSES = [
    SURVEY_INPUT_PROCESSING_STATES.readyForReview,
    SURVEY_INPUT_PROCESSING_STATES.inReview,
    SURVEY_INPUT_PROCESSING_STATES.readyForAdminQC,
    SURVEY_INPUT_PROCESSING_STATES.flaggedForAdminReview,
    SURVEY_INPUT_PROCESSING_STATES.flaggedForLeadReview,
    SURVEY_INPUT_PROCESSING_STATES.pendingLeadReview
];

export const getAvailableECSStatuses = async () => {
    const isAdminUser = await checkUserGroup(USER_GROUPS.ADMIN);
    
    if (isAdminUser) {
        return Object.entries(SURVEY_INPUT_PROCESSING_STATES);
    }
    
    return Object.entries(SURVEY_INPUT_PROCESSING_STATES)
        .filter(([_, value]) => DATA_PROVIDER_ALLOWED_STATUSES.includes(value));
}; 